import { FlowFontFamily, variants } from '../components/Typography/Typography.overrides'
import type { TypographyVariantsOptions } from '@mui/material/styles'

export const typography: TypographyVariantsOptions = {
  fontFamily: FlowFontFamily.INTER,
  ...variants
}
